import * as AsyncActions from './async';
import { smsingSlice } from './slice';

export * from './smsing';
export * from './state';

const Actions = smsingSlice.actions;
const Reducer = smsingSlice.reducer;

export { Reducer, Actions, AsyncActions };
